/*
  Zenino: cosul instant (snippets/cart-drawer.liquid).
  - Orice adaugare (butonul de pe pagina de produs, „Adauga-le pe amandoua”, recomandarile din cos) deschide cosul
    pe loc, cu produsul deja in lista, numarul din antet, totalul si bara de livrare la zi. Shopify confirma in fundal
    (o singura cerere, cu sertarul randat in raspuns); la eroare randul provizoriu dispare si apare mesajul.
  - Cantitatea si stergerea (cart-items.js) se vad pe loc; aici se recalculeaza preturile, totalul si bara.
  - Recomandarile vin separat (sections/zn-cart-reco.liquid) si se tin minte pe produsele din cos (sessionStorage).
  Folosit din product-form.js, zn-fbt.js si cart-items.js prin window.znCart.
*/
(function () {
  'use strict';

  const drawer = () => document.getElementById('cart-drawer');
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- bani, in formatul magazinului ---------- */

  function money(cents) {
    const d = drawer();
    const format = (d && d.dataset.moneyFormat) || '{{amount_with_comma_separator}} lei';
    const value = (Number(cents) || 0) / 100;
    const fmt = (decimals, thousands, point) => {
      const [int, frac] = value.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? point + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => ({
      amount: fmt(2, ',', '.'),
      amount_no_decimals: fmt(0, ',', '.'),
      amount_with_comma_separator: fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
      amount_with_apostrophe_separator: fmt(2, "'", '.')
    }[key] || fmt(2, '.', ',')));
  }

  /* „74,99 lei” -> 7499 (cand pagina nu are pretul in bani) */
  function centsOf(text) {
    const m = String(text || '').replace(/\s/g, '').match(/(\d[\d.]*)(,(\d{1,2}))?/);
    if (!m) return 0;
    return Number(m[1].replace(/\./g, '')) * 100 + Number((m[3] || '0').padEnd(2, '0'));
  }

  /* ---------- numarul de produse ---------- */

  function plural(el, n) {
    if (n === 1) return el.dataset.one;
    const mod = n % 100;
    return (n === 0 || (mod >= 1 && mod <= 19) ? el.dataset.few : el.dataset.other).replace('__n__', n);
  }

  function setCount(n) {
    const d = drawer();
    const el = d && d.querySelector('[data-zn-cart-count]');
    if (el) {
      /* scriem doar cand se schimba ceva: scrierea insasi e o modificare pe care o vede observatorul de mai jos */
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
      const text = n > 0 ? plural(el, n) : el.textContent;
      if (el.textContent !== text) el.textContent = text;
    }
    const bubble = document.querySelector('#cart-icon-bubble .header__cart-count [aria-hidden]');
    if (bubble && bubble.textContent !== String(n)) bubble.textContent = n;
  }

  /* ---------- totaluri calculate din randuri, pe loc ---------- */

  function rows() {
    const d = drawer();
    return d ? Array.from(d.querySelectorAll('#cart-items .zn-line:not(.is-removing)')) : [];
  }

  function qtyOf(row) {
    const input = row.querySelector('[name="updates[]"]');
    return input ? Math.max(0, Number(input.value) || 0) : Number(row.dataset.qty || 0);
  }

  function recompute() {
    const d = drawer();
    if (!d) return;
    let qty = 0;
    let total = 0;
    let was = 0;
    rows().forEach((row) => {
      const q = qtyOf(row);
      const unit = Number(row.dataset.unit || 0);
      const unitWas = Math.max(Number(row.dataset.unitWas || 0), unit);
      qty += q;
      total += unit * q;
      was += unitWas * q;
      if (!unit) return;
      const price = row.querySelector('.zn-line__price strong');
      if (price) price.textContent = money(unit * q);
      const old = row.querySelector('.zn-line__price s');
      if (old) old.textContent = money(unitWas * q);
    });

    const totalEl = d.querySelector('[data-zn-total]');
    if (totalEl && qty) totalEl.textContent = money(total);
    const save = d.querySelector('.zn-cart__save-amount');
    if (save && was > total) save.textContent = money(was - total);

    const ship = d.querySelector('[data-zn-ship]');
    if (ship && qty) {
      const min = Number(ship.dataset.min) || 24900;
      const left = min - total;
      ship.classList.toggle('is-free', left <= 0);
      const text = ship.querySelector('.zn-cart__ship-text');
      if (text) text.innerHTML = left > 0 ? ship.dataset.left.replace('__a__', esc(money(left))) : CHECK + esc(ship.dataset.free);
      const bar = ship.querySelector('.zn-cart__bar > span');
      if (bar) bar.style.width = `${Math.min(100, Math.round((total * 100) / min))}%`;
    }
    setCount(qty);
  }

  /* un rand iese din lista cu o animatie scurta, apoi dispare (cererea la Shopify pleaca in paralel) */
  function collapse(el) {
    if (!el || el.classList.contains('is-removing')) return;
    el.style.height = `${el.offsetHeight}px`;
    el.classList.add('is-removing');
    requestAnimationFrame(() => { el.style.height = '0px'; });
  }

  /* ---------- deschiderea cosului ---------- */

  function open() {
    const d = drawer();
    if (d && d.getAttribute('open') === null && typeof d.open === 'function') d.open();
  }

  function clearError() {
    const box = document.getElementById('cart-errors');
    if (box) {
      box.textContent = '';
      box.hidden = true;
    }
  }

  /* mesajul Shopify cand spune ceva despre produs (stoc), altfel mesajul general al temei */
  function showError(message) {
    const box = document.getElementById('cart-errors');
    if (!box) return;
    box.textContent = message || (window.theme && window.theme.strings && window.theme.strings.cartError) || '';
    box.hidden = !box.textContent;
  }

  /* ---------- adaugarea instanta ---------- */

  let seq = 0;
  const jobs = new Map();

  function listFor(d) {
    const items = d.querySelector('#cart-items');
    if (!items) return null;
    let list = items.querySelector('.zn-cart__lines');
    if (!list) {
      /* cosul era gol: lista apare in locul mesajului „Cosul tau este gol” */
      const empty = items.querySelector('.zn-cart__empty');
      if (empty) empty.hidden = true;
      const content = d.querySelector('.drawer__content');
      if (content) content.classList.remove('drawer__content--flex', 'grow', 'flex', 'items-center');
      list = document.createElement('ul');
      list.className = 'zn-cart__lines';
      list.setAttribute('role', 'list');
      items.prepend(list);
    }
    return list;
  }

  function pendingRow(line) {
    const qty = line.qty || 1;
    const li = document.createElement('li');
    li.className = 'zn-line zn-line--pending';
    li.dataset.variantId = line.id;
    li.dataset.unit = line.price || 0;
    li.dataset.unitWas = Math.max(Number(line.compare) || 0, Number(line.price) || 0);
    li.dataset.qty = qty;
    const was = Number(li.dataset.unitWas) > Number(li.dataset.unit) ? `<s>${esc(money(li.dataset.unitWas * qty))}</s>` : '';
    li.innerHTML = `
      <span class="zn-line__img">${line.image ? `<img src="${esc(line.image)}" width="84" height="84" alt="">` : ''}</span>
      <div class="zn-line__body">
        <div class="zn-line__top"><span class="zn-line__name">${esc(line.title)}</span></div>
        ${line.variant ? `<p class="zn-line__variant">${esc(line.variant)}</p>` : ''}
        <div class="zn-line__bottom">
          <span class="zn-line__pending-qty" aria-hidden="true">${qty}</span>
          <p class="zn-line__price">${was}<strong>${line.price ? esc(money(line.price * qty)) : ''}</strong></p>
        </div>
      </div>`;
    return li;
  }

  /* aplica pe randuri adaugarile care inca asteapta raspuns (dupa ce Shopify a redesenat cosul pentru alta cerere) */
  function replay(job) {
    const d = drawer();
    const list = d && listFor(d);
    if (!list) return;
    job.made = job.lines.map((line) => {
      const row = d.querySelector(`#cart-items .zn-line[data-variant-id="${line.id}"]:not(.zn-line--pending)`);
      const input = row && row.querySelector('[name="updates[]"]');
      if (input) {
        input.value = (Number(input.value) || 0) + (line.qty || 1);
        row.classList.add('is-syncing');
        return { input, row, delta: line.qty || 1 };
      }
      const pending = pendingRow(line);
      list.prepend(pending);
      return { row: pending, pending: true };
    });
  }

  /**
   * Arata produsele in cos imediat si deschide cosul. Intoarce un bilet pentru finish() sau fail().
   * @param {Array<{id:number, qty?:number, title:string, variant?:string, price?:number, compare?:number, image?:string}>} lines
   */
  function begin(lines) {
    const d = drawer();
    if (!d || !lines || !lines.length) return null;
    const token = ++seq;
    const job = { lines, made: [] };
    jobs.set(token, job);
    clearError();
    replay(job);
    recompute();
    open();
    return token;
  }

  /** Raspunsul Shopify (cu `sections`) inlocuieste randurile provizorii cu cele reale. */
  async function finish(token, data) {
    jobs.delete(token);
    const d = drawer();
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
    if (d && data && data.sections && typeof d.renderContents === 'function') {
      await d.renderContents(data, false);
    } else if (d && typeof d.refresh === 'function') {
      await d.refresh(true);
    }
    /* alte adaugari pornite intre timp, inca fara raspuns */
    jobs.forEach(replay);
    recompute();
    reco();
  }

  /** Shopify a refuzat: randurile provizorii dispar, cantitatile revin, apare mesajul. */
  function fail(token, message) {
    const job = jobs.get(token);
    jobs.delete(token);
    (job ? job.made : []).forEach((m) => {
      if (m.pending) m.row.remove();
      else if (m.input) {
        m.input.value = Math.max(0, (Number(m.input.value) || 0) - m.delta);
        m.row.classList.remove('is-syncing');
      }
    });
    const d = drawer();
    if (d && !d.querySelector('#cart-items .zn-line')) {
      /* cosul era gol: il aducem inapoi asa cum il stie Shopify */
      if (typeof d.refresh === 'function') d.refresh(true);
    }
    recompute();
    showError(message);
  }

  /* o singura cerere pentru toate produsele, cu sertarul si bulina din antet randate in raspuns */
  async function post(items) {
    const d = drawer();
    const section = d && d.closest('.shopify-section');
    const sections = ['cart-icon-bubble'];
    if (section) sections.push(section.id.replace('shopify-section-', ''));
    const res = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname })
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) {
      const err = new Error('cart');
      /* mesajul Shopify il aratam doar cand spune ceva despre produs (stoc, cantitate: 422) */
      err.description = res.status === 422 && typeof data.description === 'string' ? data.description : '';
      throw err;
    }
    return data;
  }

  /* datele produsului de pe pagina de produs, pentru randul provizoriu */
  function lineFromProductForm(form, formData) {
    const id = Number(formData.get('id'));
    const qty = Math.max(1, Number(formData.get('quantity')) || 1);
    const section = form.closest('.cc-main-product') || form.closest('.shopify-section') || document;
    const picker = section.querySelector('variant-picker');
    const product = picker && picker.data && picker.data.product;
    const variant = product && product.variants ? product.variants.find((v) => v.id === id) : null;
    const nameEl = section.querySelector('.product-title .zn-t__name') || section.querySelector('.product-title');
    const priceEl = section.querySelector('.product-info__price .price__current');
    let image = variant && variant.featured_image ? variant.featured_image.src : '';
    if (!image) {
      const img = section.querySelector('#product-media img');
      image = img ? img.currentSrc || img.src : '';
    }
    if (image && /cdn\/shop|cdn\.shopify\.com/.test(image)) image = image.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '') + (image.includes('?') ? '&' : '?') + 'width=180';
    return {
      id,
      qty,
      title: nameEl ? nameEl.textContent.trim() : '',
      variant: variant && product.variants.length > 1 ? variant.title : '',
      price: variant ? variant.price : centsOf(priceEl && priceEl.textContent),
      compare: variant ? variant.compare_at_price : 0,
      image
    };
  }

  /* ---------- recomandarile din cos ---------- */

  let recoCtl = null;
  let recoTimer = null;

  function recoKey() {
    const ids = rows().filter((r) => !r.classList.contains('zn-line--pending')).map((r) => r.dataset.productId).filter(Boolean);
    return ids.length ? `zn-reco:${ids.join(',')}` : '';
  }

  function cached(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function remember(key, html) {
    try { sessionStorage.setItem(key, html); } catch (e) { /* memoria browserului e plina sau blocata */ }
  }

  function fill(key, html) {
    const slot = drawer() && drawer().querySelector('[data-zn-reco]');
    if (!slot || slot.dataset.key === key) return;
    slot.innerHTML = html;
    slot.dataset.key = key;
  }

  async function loadReco() {
    const d = drawer();
    const slot = d && d.querySelector('[data-zn-reco]');
    if (!slot) return;
    const key = recoKey();
    if (!key) {
      slot.innerHTML = '';
      slot.dataset.key = '';
      return;
    }
    const hit = cached(key);
    if (hit !== null) {
      fill(key, hit);
      return;
    }
    if (recoCtl) recoCtl.abort();
    recoCtl = new AbortController();
    try {
      const res = await fetch(`${root()}?section_id=zn-cart-reco`, { signal: recoCtl.signal });
      if (!res.ok) return;
      const tpl = document.createElement('template');
      tpl.innerHTML = await res.text();
      const box = tpl.content.querySelector('.zn-xs');
      const html = box ? box.outerHTML : '';
      remember(key, html);
      /* cosul s-a schimbat intre timp: alta cerere aduce recomandarile potrivite */
      if (recoKey() === key) fill(key, html);
    } catch (e) { /* intrerupta de o cerere mai noua sau fara retea: raman cele de dinainte */ }
  }

  /* din memorie pe loc; din retea cel mult o data la 150 ms, oricate schimbari ar veni */
  function reco() {
    const key = recoKey();
    const hit = key ? cached(key) : '';
    if (hit !== null) fill(key, hit || '');
    clearTimeout(recoTimer);
    recoTimer = setTimeout(loadReco, hit !== null ? 0 : 150);
  }

  /* ---------- „Adauga” din recomandarile din cos ---------- */

  async function addFromReco(btn) {
    const item = btn.closest('[data-zn-xs]');
    if (!item || item.classList.contains('is-removing')) return;
    const img = item.querySelector('img');
    const name = item.querySelector('.zn-xs__name');
    const id = Number(btn.dataset.id);
    const token = begin([{
      id,
      qty: 1,
      title: name ? name.textContent.trim() : '',
      variant: btn.dataset.variant || '',
      price: Number(btn.dataset.price) || 0,
      compare: Number(btn.dataset.compare) || 0,
      image: img ? img.currentSrc || img.src : ''
    }]);
    collapse(item);
    try {
      const data = await post([{ id, quantity: 1 }]);
      await finish(token, data);
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: id, items: data.items } }));
    } catch (err) {
      item.classList.remove('is-removing');
      item.style.height = '';
      fail(token, err.description);
    }
  }

  function choose(select) {
    const item = select.closest('[data-zn-xs]');
    const option = select.options[select.selectedIndex];
    const btn = item.querySelector('[data-zn-cart-add]');
    if (btn) {
      btn.dataset.id = option.value;
      if (option.dataset.cents) btn.dataset.price = option.dataset.cents;
      if (option.dataset.compare) btn.dataset.compare = option.dataset.compare;
      if (option.dataset.title) btn.dataset.variant = option.dataset.title;
    }
    const price = item.querySelector('[data-zn-xs-price]');
    if (price) price.textContent = option.dataset.price;
    const was = item.querySelector('[data-zn-xs-was]');
    if (was) {
      was.hidden = !option.dataset.was;
      was.textContent = option.dataset.was || '';
    }
    const img = item.querySelector('[data-zn-xs-img]');
    if (img && option.dataset.image) img.src = option.dataset.image;
  }

  document.addEventListener('click', (evt) => {
    const btn = evt.target.closest('#cart-drawer [data-zn-cart-add]');
    if (btn) addFromReco(btn);
  });

  document.addEventListener('change', (evt) => {
    const select = evt.target.closest('#cart-drawer [data-zn-xs-select]');
    if (select) choose(select);
  });

  /* oricare ar fi calea, numarul din antet si din cos urmeaza randurile */
  document.addEventListener('on:line-item:change', () => recompute());
  const watch = () => {
    const d = drawer();
    if (!d || d.dataset.znWatch) return;
    d.dataset.znWatch = '1';
    new MutationObserver(() => {
      const n = rows().reduce((sum, row) => sum + qtyOf(row), 0);
      setCount(n);
    }).observe(d, { childList: true, subtree: true });
    /* recomandarile se pregatesc in fundal, ca la deschiderea cosului sa fie deja acolo */
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200));
    if (rows().length) idle(() => reco());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  window.znCart = { begin, finish, fail, post, recompute, collapse, reco, money, cents: centsOf, lineFromProductForm };
})();
